export var HRLineState = { Withdrawn: 6 };
/* TODO(developer): Refactor this file to lower the cyclomatic complexity */
/* tslint:disable:cyclomatic-complexity no-parameter-reassignment */
var DataHelper = /** @class */ (function () {
    function DataHelper() {
    }
    /* istanbul ignore next */
    DataHelper.compare = function (a1, a2) {
        if (typeof a1 === "string" && typeof a2 === "number") {
            a1 = parseInt(a1, 10);
        }
        else if (typeof a1 === "number" && typeof a2 === "string") {
            a2 = parseInt(a2, 10);
        }
        else if (typeof a1 === "string" && typeof a2 === "string") {
            a1 = parseInt(a1, 10);
            a2 = parseInt(a2, 10);
        }
        var a1e = typeof a1 === "undefined" || a1 === null || a1 === "";
        var a2e = typeof a2 === "undefined" || a2 === null || a2 === "";
        if (a1e && a2e) {
            return 0;
        }
        if (a1e) {
            return -1;
        }
        if (a2e) {
            return 1;
        }
        if (a1 > a2) {
            return 1;
        }
        if (a1 < a2) {
            return -1;
        }
        return 0;
    };
    /* istanbul ignore next */
    DataHelper.compareByLineTypeID = function (line1, line2) {
        var l1f, l2f;
        //1st/2nd favorites must be always last
        switch (line1.lineTypeId) {
            case 26: //1st fav
                l1f = 1;
                break;
            case 28: //2nd fav
                l1f = 2;
                break;
            default:
                l1f = 0;
        }
        switch (line2.lineTypeId) {
            case 26: //1st fav
                l2f = 1;
                break;
            case 28: //2nd fav
                l2f = 2;
                break;
            default:
                l2f = 0;
        }
        return this.compare(l1f, l2f);
    };
    DataHelper.compareByLineStateID = function (line1, line2) {
        //Sort by withdrawn or not
        /* istanbul ignore next */
        var l1w = (line1.lineStateId === HRLineState.Withdrawn ? 1 : 0);
        /* istanbul ignore next */
        var l2w = (line2.lineStateId === HRLineState.Withdrawn ? 1 : 0);
        /* istanbul ignore next */
        return this.compare(l1w, l2w);
    };
    // issues with tests based on 
    /* istanbul ignore next */
    DataHelper.getUkTime = function (d) {
        // TODO : finish integration of TimeControler
        var nowUTC;
        var clientDate = new Date();
        var timeZoneOffsetInMinutes = clientDate.getTimezoneOffset();
        nowUTC = clientDate;
        nowUTC.setMinutes(nowUTC.getMinutes() + timeZoneOffsetInMinutes);
        var isDST = nowUTC.isDaylightSavingTimeInUK();
        /* istanbul ignore next */
        var resultDateTime = new Date(d);
        /* istanbul ignore next */
        resultDateTime.setHours(resultDateTime.getHours() + (isDST ? 1 : 0));
        return resultDateTime;
    };
    ;
    DataHelper.getUKDateTime = function (d) {
        var date = new Date(d);
        /* istanbul ignore next */
        var isDST = date.isDaylightSavingTimeInUK();
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        /* istanbul ignore next */
        date.setHours(isDST ? date.getHours() + 1 : date.getHours());
        return date;
    };
    ;
    DataHelper.chainSort = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        /* istanbul ignore next */
        return function (a, b) {
            /* istanbul ignore next */
            for (var i = 0; i < params.length; i++) {
                /* istanbul ignore next */
                var p = params[i](a, b);
                /* istanbul ignore next */
                if (p !== 0) {
                    return p;
                }
            }
            /* istanbul ignore next */
            return 0;
        };
    };
    return DataHelper;
}());
export { DataHelper };
//# sourceMappingURL=DataHelper.js.map